module.exports = __webpack_public_path__ + "static/media/bacardi.fdced51c.png";